/* eslint-disable jira/filename-case */

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { UNSAFE_initIfNeeded } from '@jira/platform__utils-feature-gates-unsafe-init/src/index.tsx';
import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

type WindowFlagVars = {
	__SSR_SYNC_READ_EXP_VAL__:
		| undefined
		| ((experimentName: string, param: string, defaultValue: unknown) => unknown);
	__SSR_SYNC_DYNAMIC_CONFIG_VALUE__:
		| undefined
		| ((experimentName: string) => Record<string, unknown> | undefined);
	_statsigValuesReady: boolean | undefined;
};

let cache: Set<string>;
export default function killswitch(name: string): boolean {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const globalVar = (getWindow() ?? globalThis) as unknown as WindowFlagVars;

	try {
		if (!cache) {
			if (
				__SERVER__ &&
				typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' &&
				// if global variable is ready, then don't reach out to native
				// API, stay within js runtime is faster
				!globalVar._statsigValuesReady
			) {
				try {
					// oxlint-disable-next-line typescript/consistent-type-assertions
					const config = globalVar.__SSR_SYNC_READ_EXP_VAL__('killswitch', 'value', []) as string[];
					cache = new Set(config.map((d: string) => d.toLowerCase()));
					return cache.has(name.toLowerCase());
				} catch (error) {
					// oxlint-disable-next-line no-console
					console.error(
						JSON.stringify({
							// oxlint-disable-next-line typescript/consistent-type-assertions
							message: (error as Error).message,
							// oxlint-disable-next-line typescript/consistent-type-assertions
							stack: (error as Error).stack,
						}),
					);
				}
			} else {
				UNSAFE_initIfNeeded();
				// Using this to access a dynamic parameter
				// Killswitching is known destructive, hence the lack of exposure
				// eslint-disable-next-line jira/ff/use-recommended-utils
				const config = FeatureGates.getExperimentValue<Array<string>>('killswitch', 'value', [], {
					fireExperimentExposure: false,
				});
				cache = new Set(config.map((d: string) => d.toLowerCase()));
			}
		}
		return cache.has(name.toLowerCase());
	} catch (e) {
		return false;
	}
}
